module.exports = __webpack_public_path__ + "img/img-recession.aba71306.png";